import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from 'vue-property-decorator';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(['formCallIsShown', 'breakpoint'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['videoLink', 'quiz']),
        ...dataMapper.mapGetters(['quizAnswer'])
    },
    methods: {
        ...dataMapper.mapMutations(['updateQuizField', 'clearQuiz'])
    }
});
let StepsQuizCheckbox = class StepsQuizCheckbox extends Mixins(UiMappers, DataMappers) {
    get isGtLg() { return this.breakpoint === 'lg' || this.breakpoint === 'xl'; }
    get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm'; }
    get steps() { return this.quiz.data; }
    get colAmount() { return this.breakpoint === 'xs' ? 1 : 2; }
    get itemsPerCol() { return this.colAmount === 2 ? 3 : this.step.answers.length; }
    updateValue(value) {
        // this.updateQuizField({index, value, valueIndex})
        this.$emit('updateValue', { index: this.stepIndex, value });
    }
};
__decorate([
    Prop()
], StepsQuizCheckbox.prototype, "step", void 0);
__decorate([
    Prop()
], StepsQuizCheckbox.prototype, "stepIndex", void 0);
StepsQuizCheckbox = __decorate([
    Component({
        components: {},
    })
], StepsQuizCheckbox);
export default StepsQuizCheckbox;
